// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"31b0143b","364":"ba3affba","378":"8d7200a9","474":"5bf385a0","523":"e7759630","820":"5d79090b"}[chunkId] + ".chunk.js";
};